export function decodeJwt(token) {
    try {
        if (!token || typeof token !== 'string') {
            console.error('Token inválido ou undefined:', token);
            return null;
        }
        const base64Url = token.split('.')[1];
        if (!base64Url) {
            console.error('Token malformado: não contém payload');
            return null;
        }
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join(''));
        return JSON.parse(jsonPayload);
    }
    catch (error) {
        console.error('Erro ao decodificar JWT:', error);
        return null;
    }
}
export function getPersonIdFromToken(token) {
    const payload = decodeJwt(token);
    return payload?.personId || null;
}
export function getEmailFromToken(token) {
    const payload = decodeJwt(token);
    return payload?.email || null;
}
export function getPreferredUsernameFromToken(token) {
    const payload = decodeJwt(token);
    return payload?.preferred_username || null;
}
export function getPartyIdFromToken(token) {
    const payload = decodeJwt(token);
    return payload?.partyId || null;
}
export function isTokenExpired(token) {
    const payload = decodeJwt(token);
    if (!payload)
        return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp < currentTime;
}
export function isTokenExpiredWithThreshold(exp, thresholdSeconds = 120) {
    const currentTime = Math.floor(Date.now() / 1000);
    return currentTime > exp - thresholdSeconds;
}
export function getTokenInfo(token) {
    const payload = decodeJwt(token);
    if (!payload)
        return null;
    return {
        personId: payload.personId,
        partyId: payload.partyId,
        email: payload.email,
        emailVerified: payload.email_verified,
        preferredUsername: payload.preferred_username,
        roles: payload.realm_access?.roles || [],
        accountRoles: payload.resource_access?.account?.roles || [],
        exp: payload.exp,
        iat: payload.iat,
    };
}
